<div *ngIf="previewData | async as data" class="title d-flex flex-column">
  <span class="title-report">{{ data.title }}</span>
  <span class="title-date typography-grey">{{ data.displayEndDate }}</span>
</div>
